import React, { memo } from 'react';
import PropTypes from 'prop-types';

const PromotionInfo = ({ info }) => (
  <div className="m-4">
    <p className="text-lg font-bold">Special Promotion Available</p>
    <p className="text-gray-500">Code: {info.code}</p>
    <hr />
    <p className="text-lg font-bold">{info.name}</p>
    <div dangerouslySetInnerHTML={{ __html: info.description }} />
  </div>
);

PromotionInfo.propTypes = {
  info: PropTypes.shape().isRequired,
};

export default memo(PromotionInfo);
